module.exports = __webpack_public_path__ + "img/DOWNLOAD.a422c4d9.svg";